module.exports = __webpack_public_path__ + "media/images/lp/img_voice_03-0a42ebdb45f8bc6f6870ce124ff48010.png";